import { t } from 'i18next';

interface Props {
  title?: string;
  text?: string | null;
}

export const ErrorWrapper = ({ title, text }: Props) => {
  const getDetails = () => {
    const searchParams = new URL(window.location.href).searchParams;
    const details: Record<string, string>[] = [];

    searchParams.forEach((value, key) => details.push({ key: value }));

    return details;
  };

  return (
    <div className='error-container'>
      <div>
        <h5>{title}</h5>
        <p>{text}</p>
        {getDetails().map((detail) => (
          <div key={detail.key} className='error-details'>
            {detail.key}
          </div>
        ))}
      </div>
    </div>
  );
};

export const Forbidden = () => <ErrorWrapper title={t('error.ForbiddenTitle')} text={t('error.ForbiddenText')} />;
export const NotFound = () => <ErrorWrapper title={t('error.NotFoundTitle')} text={t('error.NotFoundText')} />;
export const ExpiredInvite = () => <ErrorWrapper title={t('error.ExpiredInviteTitle')} text={t('error.ExpiredInviteText')} />;
export const FailedInvite = () => <ErrorWrapper title={t('error.FailedInviteTitle')} text={t('error.FailedInviteText')} />;
export const UnAuthanticated = () => <ErrorWrapper title={t('error.UnAuthanticatedTitle')} text={t('error.UnAuthanticatedText')} />;
